// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___o7PVe","empty":"styles__empty___gLTSP","attach":"styles__attach___uUDdl"};